import { Component, OnInit } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
    selector: "app-driveb-mandatory-data-update-car-workshop-dialog",
    templateUrl: "./mandatory-data-update-car-workshop-dialog.component.html",
    styleUrls: ["./mandatory-data-update-car-workshop-dialog.component.scss"],
    standalone: false
})
export class MandatoryDataUpdateCarWorkshopDialogComponent implements OnInit {
  constructor(
    private matDialogRef: MatDialogRef<MandatoryDataUpdateCarWorkshopDialogComponent>
  ) {}

  ngOnInit() {}

  onClickProceedButton() {
    this.matDialogRef.close();
  }
}
